import axios from 'axios';
import api from '@/api/auth-interceptor';

// API
// const devApi = axios.create({
//   baseURL: process.env.VUE_APP_API2,
// })

const authApi = axios.create({
  baseURL: process.env.VUE_APP_AUTH
});

const refreshOptions = token => {
  const headers = {
    headers: { 'X-AUTH-TOKEN': token }
  };

  return headers;
};

// SEARCH QUERY
function buildQuery(params) {
  // Required
  const start = `?start=${params.start}`;
  const end = `&end=${params.end}`;
  const sort = `&sort=${params.sort}`;
  const order = `&order=${params.order}`;

  // Optional
  const search = bulidFilterQuery(params.search, '&q='); // Text search
  const userId = bulidFilterQuery(params.userId, '&userId='); // Filter by UserId
  const hardFilter = bulidFilterQuery(params.hardFilter, '&id[]='); // Filter by Id
  const invert = bulidFilterQuery(params.invert_is_table_key, '&invert_is_table_key=');

  // const filters = `&paramName=paramValue` // Filter by param (multiple result), Not Implemented Yet

  function bulidFilterQuery(optionalParam, addition) {
    if (optionalParam === null) {
      return '';
    } else if (typeof optionalParam === 'object') {
      return addition + optionalParam.join(addition);
    } else if (typeof optionalParam === 'string' || typeof optionalParam === 'boolean') {
      return `${addition}${optionalParam}`;
    } else {
      return '';
    }
  }

  function combineParams() {
    return `${start}${end}${sort}${order}${search}${hardFilter}${userId}${invert}`;
  }

  const outputParams = combineParams;

  return outputParams();
}

export default {
  // AUTH
  auth: data => authApi.post('/login', data),

  refresh: token => authApi.post('/refresh', '', refreshOptions(token)),

  // CURRENT USER
  getUser: () => api.get('/userinfo'),

  // FAVOURITES
  getFavouriteGroups: () => api.get(`/favouritegroups`),

  postFavouriteGroup: data => api.post(`/favouritegroups`, data),

  patchFavouriteGroup: (id, data) => api.patch(`/favouritegroups/${id}`, data),

  deleteFavouriteGroup: id => api.delete(`/favouritegroups/${id}`),

  postFavourite: data => api.post(`/favourites`, data),

  deleteFavourite: id => api.delete(`/favourites/${id}`),

  // TABLES
  getTables: params => api.get('/tables' + buildQuery(params)),

  getTablesHeader: () => api.get('/tables_header'),

  getTable: id => api.get(`/tables/${id}`),

  getTableDetails: id => api.get(`/tablesDetails/${id}`),

  // CATEGORIES
  getCategories: () => api.get('/categories'),

  // DASHBOARDS
  getDashboards: () => api.get(`/dashboards`),

  getDashboard: id => api.get(`/dashboards/${id}`),

  getExtended: (id, extendedId, comparedId = null) => {
    if (comparedId !== null) {
      return api.get(`/dashboards/${id}/compare/${extendedId}/${comparedId}`);
    } else {
      return api.get(`/dashboards/${id}/extended/${extendedId}`);
    }
  },

  // TEMPLATES
  getTemplatesHeader: () => api.get('/referencetemplatesheader'),

  getTemplates: params => api.get('/referencetemplates' + buildQuery(params)),

  getTemplate: id => api.get(`/referencetemplates/${id}`),

  postTemplate: data => api.post(`/referencetemplates/`, data),

  patchTemplate: (id, data) => api.patch(`/referencetemplates/${id}`, data),

  deleteTemplate: id => api.delete(`/referencetemplates/${id}`),

  // CHARTS
  getChartsHeader: () => api.get('/chartheader'),

  getCharts: params => api.get('/chart' + buildQuery(params)),

  getChart: id => api.get(`/chart/${id}`),

  postChart: data => api.post(`/chart/`, data),

  patchChart: (id, data) => api.patch(`/chart/${id}`, data),

  deleteChart: id => api.delete(`/chart/${id}`),

  // DOCUMENTS
  getDocumentsHeader: () => api.get('/referenceheader'),

  getDocuments: params => api.get('/reference' + buildQuery(params)),

  postDocument: data => api.post(`/reference/`, data),

  patchDocument: (id, data) => api.patch(`/reference/${id}`, data),

  getDocument: id => api.get(`/reference/${id}`),

  deleteDocument: id => api.delete(`/reference/${id}`),

  documentExport: (id, data) => api.post(`/referenceexport/${id}`, data),

  // SERIES
  getSeries: () => api.get(`/series`),

  getSerie: id => api.get(`/series/${id}`),

  // CHART GENERATOR

  getChartData: data => api.post('/chartgenerator/', data)
};
